import type { TOC } from '@ember/component/template-only'
import type { ReportingMathsCourseProgressAveragesRoute } from 'district-ui-client/reporting/ui-scope/maths/course-progress/averages/route'
import { DetailedPageWrapper } from 'district-ui-client/components/reporting/detailed-page-wrapper'
import { not } from 'ember-truth-helpers'
import { ChartsCourseProgressAverages } from 'district-ui-client/components/charts/course-progress/averages/component'
import { t } from 'ember-intl'
import RouteTemplate from 'ember-route-template'
import { Precinct } from 'district-ui-client/domain/precinct'

interface Signature {
  Args: {
    model: ModelFor<ReportingMathsCourseProgressAveragesRoute>
  }
}

export const ReportingMathsCourseProgressAveragesRouteTemplate: TOC<Signature> = <template>
  <DetailedPageWrapper @empty={{not @model.courseProgressAverages}}>
    {{#each @model.courseProgressAverages as |gradeData|}}
      <div class="detailed-chart-wrapper">
        <ChartsCourseProgressAverages
          class="h-full"
          @data={{gradeData}}
          @precinct={{Precinct.MS_LESSONS}}
          @tooltip={{t "reporting.tooltips.courseProgressAverages"}}
          @title={{t "reporting.chartTitles.courseProgressAverages"}}
        />
      </div>
    {{/each}}
  </DetailedPageWrapper>
</template>

export default RouteTemplate(ReportingMathsCourseProgressAveragesRouteTemplate)
